import { render } from "./DragSort.vue?vue&type=template&id=6ef77e63&scoped=true"
import script from "./DragSort.vue?vue&type=script&lang=js"
export * from "./DragSort.vue?vue&type=script&lang=js"

import "./DragSort.vue?vue&type=style&index=0&id=6ef77e63&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef77e63"]])

export default __exports__